// export const basicURL = "https://core-dev.microlab.help/api/";
export const basicURL = "https://core.microlab.help/api/";
// const browserHost =
//   typeof window !== "undefined" ? window.location.hostname : "localhost";
// const isLanOrLocalHost =
//   browserHost === "localhost" ||
//   browserHost === "127.0.0.1" ||
//   browserHost === "0.0.0.0" ||
//   /^192\.168\./.test(browserHost) ||
//   /^10\./.test(browserHost) ||
//   /^172\.(1[6-9]|2\d|3[0-1])\./.test(browserHost);

// export const basicURL =
//   process.env.REACT_APP_API_BASE_URL ||
//   (isLanOrLocalHost
//     ? `http://${browserHost}:4000/api/`
//     : "https://api.microlab.help/api/");

export const loginURL = "auth/login";
export const socialAuthURL = "auth/social_auth";
/** GET: send OTP — same contract as the mobile app (`auth/verification`). */
export const verificationURL = "auth/verification";
export const recoverPasswordURL = "auth/recover_password";
export const authURL = "auth";
export const userURL = "user/all";
export const getTitleURL = "title/json";
export const updatePresentationPublishURL = "title/presentation/publish";
// Admin-only: toggle the `locked` flag on a catalogue slide
// (his / emb / three_d_model / emb_3d_model). Body: { title_id, locked }.
export const updateTitleLockURL = "title/lock";
export const getLibraryURL = "title/library";
export const libraryReferenceURL = "title/library/reference";
export const libraryVisibilityURL = "title/library/visibility";
export const getPackageURL = "payment/package";
export const getTransactionsURL = "payment/transaction";
/** Admin: subscription cancel survey rows */
export const subscriptionCancellationSurveysURL =
  "payment/subscription/cancellation-surveys";
export const addTitleURL = "title/title";
export const addSubTitleURL = "title/sub_title";
export const addSlideURL = "title/slide";
export const addSlideFileURL = "file/upload";
export const deleteSlideFileURL = "file";
export const getSlideByIdURL = "title/getSlideById";
export const addPinURL = "title/pin";
export const editPinURL = "title/pin";
export const deletePinURL = "title/pin";
export const swapTitleURL = "title/swapTitleOrder";
export const revenueCatSubscriptionsURL = "report/revenuecat/subscriptions";

export const quizTitleURL = "quiz/title";
export const quizContentURL = "quiz/content";
export const quizContentRandomURL = "quiz/contentRandom";
export const quizResultURL = "quiz/result";
export const getQuizResultGroupByDateURL = "quiz/getQuizResultGroupByDate";

// Professor titles (for quiz / question bank)
export const quizProfessorTitlesURL = "quiz/professor-titles";

// New quiz system (question bank + assignments + attempts)
export const quizQuestionBankURL = "quiz/question-bank";
export const quizAssignmentsURL = "quiz/assignments";
export const quizAssignedURL = "quiz/assigned";
export const quizAttemptsStartURL = "quiz/attempts/start";
export const quizAttemptsStartByCodeURL = "quiz/attempts/start-by-code";
export const quizAttemptsSubmitURL = "quiz/attempts/submit";
export const quizAttemptsMyURL = "quiz/attempts/my";
export const quizAttemptsResultURL = "quiz/attempts/result";
export const quizByTileURL = "quiz/by-tile";
export const quizBySlideURL = "quiz/by-slide";
export const quizLinkedIdsURL = "quiz/linked-ids";
export const quizHeatmapURL = "quiz/heatmap";
export const quizResultsURL = "quiz/results";
export const pushURL = "notification";
export const editTitleImageCallURL = "title/updateTitleImage";
export const getReportURL = "report/dashboard-stats";
export const getMapReportURL = "report/dashboard-map";
export const getProfStatsURL = "report/prof-stats";
export const getStorageSummaryURL = "report/storage-summary";
export const getDeviceHostsReportURL = "report/device-hosts";
export const getAddSlidePresentationURL = "universities/slides";
export const getAddSlidePresentationByTitleIdURL = "universities/slides-by-title";
export const getPublicSlidePresentationByTitleIdURL = "universities/public/slides-by-title";
export const getAddContentToSlidePresentationURL = "universities/slides/content";
export const universitiesURL = "universities";
export const getProfsForDropdownURL = "universities/profs";
export const aiGenerateQuestionURL = "ai/generate-question";
export const aiQuizInsightsURL = "ai/quiz-insights";
export const aiAskURL = "ai";
export const aiThreadMessagesURL = "ai";

/** Demo request funnel (Quiz) — saves row + emails admins (see DEMO_REQUEST_NOTIFY_EMAILS) */
export const demoRequestURL = "demo-request";

// Affiliation / earning (admin: earners list + sales progress)
export const affiliationEarnersURL = "affiliation/earners";
export const affiliationEarnerSalesURL = "affiliation/earners";

// Community ads (sponsored videos shown in community feed)
export const communityAdsURL = "question/ads";
export const allQuestionURL = "question";
export const myQuestionURL = "question/me";
export const verifiedActivityUsersURL = "question/admin/verified-activity/users";
export const verifiedActivityPostsURL = "question/admin/verified-activity/posts";
export const publicURL = "public/public";
export const activityAdminOverviewURL = "activity/admin/overview";
export const activityAdminInAppPurchaseURL = "activity/admin/in-app-purchase";
export const activityAdminTimelineURL = "activity/admin/timeline";
export const activityAdminFeatureUsageURL = "activity/admin/feature-usage";
export const activityAdminCountryPurchasePotentialURL = "activity/admin/country-purchase-potential";
export const related3dAdminListURL = "related-3d/admin/list";
export const related3dAdminLinkURL = "related-3d/admin/link";
export const related3dSuggestionsURL = "related-3d/suggestions";

/*
  Admin Copilot Usage dashboard — paginated feed of every user's Microlab
  Copilot / Lecture Lab uploads, plus full study-pack detail for the
  read-only view. Both endpoints are gated to role=admin on the backend
  (see mic-backend/src/routes/lectureLab.route.js).
*/
export const lectureLabAdminMaterialsURL = "lecture-lab/admin/materials";

/*
  Admin Packages dashboard — list/edit/soft-delete every iOS/Android/Web
  package across all languages. Backed by /payment/admin/packages on
  mic-backend, role-gated to admin.
*/
export const adminPackagesURL = "payment/admin/packages";

/*
  Admin Discount users dashboard — list earners with an active
  affiliate/discount code + their assigned packages, and update which
  packages get swapped in for buyers who use their code. Backed by
  /affiliation/admin/discount-users on mic-backend, role-gated to admin.
*/
export const adminDiscountUsersURL = "affiliation/admin/discount-users";
